export default __webpack_public_path__ + "static/AA081210_Citation_680-0093-07a_540x360-76d3ea14ebcdbd7bcb2d747c3ae97ccb.jpg";